// methods used by most components in benefits
import { segmentTrack } from '@/analytics/segment'
import { MINIMUM_GROSS_SALARY_RET_FLEX } from '@/utils/constants'

export default {
  computed: {
    features () {
      return this.$store.getters['ConfigStore/privateConfig'].user_features
    }

  },
  methods: {
    async setUserFeature (userId, feature) {
      let user = this.$store.getters['UsersStore/users'].find(
        el => el.id === userId
      )

      let featuresToAdd = user.activatedFeatures
      let featureToAddExists = user.activatedFeatures.findIndex(
        el => el.feature.code === feature
      )

      if (
        (!user.grossSalary ||
          user.grossSalary < MINIMUM_GROSS_SALARY_RET_FLEX) &&
        featureToAddExists < 0
      ) {
        this.$emit('showRequestGrossSalaryModal', {
          featureRequested: feature,
          userId: this.user.id
        })
        return
      }

      let segmentBenefitUpdatedTraits = {
        user_id: '',
        benefit_updated: '',
        status: ''
      }
      // Feature doesnt exist
      if (!(featureToAddExists !== -1)) {
        let { id: featureToBeAddedId, name: featureName } = this.features.find(
          el => el.code === feature
        )
        featuresToAdd.push({ feature: { id: featureToBeAddedId } })
        segmentBenefitUpdatedTraits.user_id = user.id
        segmentBenefitUpdatedTraits.benefit_updated = featureName
        segmentBenefitUpdatedTraits.status = true
      } else {
        // Feature exists, remove it

        let featureToRemove = user.activatedFeatures.find(
          el => el.feature.code === feature
        )

        featuresToAdd.splice(featureToAddExists, 1)
        segmentBenefitUpdatedTraits.user_id = user.id
        segmentBenefitUpdatedTraits.benefit_updated =
          featureToRemove.feature.name
        segmentBenefitUpdatedTraits.status = false
      }

      let updateInformation = {
        id: user.id,
        activatedFeatures: [...featuresToAdd]
      }

      await this.$store.dispatch('UsersStore/updateUser', updateInformation)
      segmentTrack('User benefit updated', segmentBenefitUpdatedTraits)
    }
  }
}
